import type { ApiRequestFn } from "../../types/api";
import type {
  MeterConfirmRequest,
  MeterConfirmResponse,
  MeterExtractionResponse,
  MeterExtractRequest,
  MeterProviderInfo,
  MeterReadingEntry,
  MeterSettingsResponse,
  MeterSettingsUpdate,
} from "../../types/meter";

const createMeterReadingsApi = (request: ApiRequestFn) => ({
  extract: (data: MeterExtractRequest) =>
    request<MeterExtractionResponse>("/me/meter-readings/extract", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  confirm: (data: MeterConfirmRequest) =>
    request<MeterConfirmResponse>("/me/meter-readings/confirm", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  list: (providerId: number) => request<MeterReadingEntry[]>(`/me/meter-readings?providerId=${providerId}`),

  providers: () => request<MeterProviderInfo[]>("/me/meter-readings/providers"),

  getSettings: (providerId: number) => request<MeterSettingsResponse>(`/me/meter-readings/settings?providerId=${providerId}`),

  updateSettings: (providerId: number, data: MeterSettingsUpdate) =>
    request<MeterSettingsResponse>(`/me/meter-readings/settings?providerId=${providerId}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),
});

export { createMeterReadingsApi };
